const TOP_LEVEL_ERRORS: Record<string, string> = {
    csv_file_required: 'Please select a CSV file to upload',
    invalid_file_type: 'Only .csv files are supported',
    invalid_csv_format: "This file isn't a valid CSV. Check the format and try again",
    csv_missing_required_columns:
        'Your CSV is missing required columns. Include both external_user_id and care_manager_email',
    empty_csv: 'Your CSV has no data. Add at least one row and try again',
    no_valid_rows_in_csv: 'Every row is missing an external_user_id or care_manager_email',
    all_assignments_failed: 'None of the assignments could be completed'
};

const ROW_ERROR_PREFIXES: Record<string, (value: string) => string> = {
    care_manager_not_found: (email) => `No care manager found with email ${email}`,
    commerce_failed_for: (email) => `Couldn't assign a care manager to ${email}. Please try again`
};

export const translateBulkAssignCsvError = (code: string): string => {
    if (TOP_LEVEL_ERRORS[code]) {
        return TOP_LEVEL_ERRORS[code];
    }

    const colonIndex = code.indexOf(':');
    if (colonIndex !== -1) {
        const prefix = code.slice(0, colonIndex);
        const value = code.slice(colonIndex + 1);
        const translator = ROW_ERROR_PREFIXES[prefix];
        if (translator) return translator(value);
    }

    return code;
};
